import { render, staticRenderFns } from "./ProductCreate.vue?vue&type=template&id=021b058d&"
import script from "./ProductCreate.vue?vue&type=script&lang=js&"
export * from "./ProductCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProductCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports